export default "/images/deliver2.png?52243824dbff54230e512c1096b52163";